export default [
    [
        {
            name: "LOGO / VI"
        },
        {
            name: "品牌策划"
        },
        {
            name: "包装设计"
        },
        {
            name: "网页 / H5"
        },
    ],
    [
        {
            name: "插画设计"
        },
        {
            name: "空间设计"
        },
        {
            name: "视频拍摄"
        }
    ]
]